module.exports = __webpack_public_path__ + "static/media/work_img1.e540e7f0.jpg";